export function safeJsonParse<T>(value: unknown, fallback: T): T {
  if (value === undefined || value === null || value === "") return fallback;
  if (typeof value !== "string") return value as T;

  try {
    const parsed = JSON.parse(value);
    return parsed === undefined || parsed === null ? fallback : (parsed as T);
  } catch {
    return fallback;
  }
}

export function toArray<T>(value: unknown): T[] {
  return Array.isArray(value) ? value : [];
}
